(function () {
  function initCampaignBanner(root) {
    var slides = root.querySelectorAll('[data-vny-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-vny-dot]');
    var prevBtn = root.querySelector('[data-vny-prev]');
    var nextBtn = root.querySelector('[data-vny-next]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;
    var inView = false;

    function setSlideState(slide, active) {
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('inert', '');
      }
      slide.querySelectorAll('a').forEach(function (link) {
        if (active) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      });
    }

    function goTo(index) {
      var next = ((index % slides.length) + slides.length) % slides.length;
      if (next === current) return;

      setSlideState(slides[current], false);
      setSlideState(slides[next], true);

      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[next]) {
        dots[next].classList.add('is-active');
        dots[next].setAttribute('aria-selected', 'true');
      }

      root.setAttribute('data-active-theme', slides[next].getAttribute('data-theme') || 'light');
      current = next;
    }

    function start() {
      if (reduceMotion || timer || !inView) return;
      timer = setInterval(function () {
        goTo(current + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var touchStartX = null;
    root.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        goTo(deltaX < 0 ? current + 1 : current - 1);
      }
      touchStartX = null;
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView) {
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(root);
    } else {
      inView = true;
      start();
    }
  }

  function init() {
    document.querySelectorAll('[data-vny-campaign-banner]').forEach(initCampaignBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
